import { dispatch } from '../../../services/events';
import { DISPATCH_OPEN_GAMEIFRAME_EVENT } from './constants';

export function openGameIFrame() {
  dispatch(DISPATCH_OPEN_GAMEIFRAME_EVENT);
}
